import { DocumentIcon } from '@heroicons/react/24/outline'
import type { MapperConfig } from '../mapperConfigs'

export const bom: MapperConfig = {
  name: 'Top Level BOM',
  type: 'Upload',
  orgIds: ['raco'],
  rootIsTopLevel: true,
  noProject: true,
  Logo: DocumentIcon,
  importOutputFields: {
    metadata: []
  },
  standardizeBom: {
    columns: {
      metadata: {
        'r-number': {
          value: '{{row.r_number}}',
          type: 'simple'
        },
        mpn: {
          value: '{{row.mpn}}',
          type: 'simple'
        }
      },
      summary: {
        type: 'ignore'
      },
      quantity: {
        value: '{{row.quantity}}',
        type: 'simple'
      },
      units: {
        value: 'each',
        type: 'simple'
      },
      categoryId: {
        value: 'other',
        type: 'simple'
      },
      isOffTheShelf: {
        type: 'ignore'
      },
      hierarchy: {
        value: '{{row.hierarchy}}',
        type: 'simple'
      },
      partNumber: {
        value: '{{row.part_number}}',
        type: 'simple'
      },
      name: {
        value: '{{row.name}}',
        type: 'simple',
      },
      referenceDesignator: {
        value: '{{row.reference_designator}}',
        type: 'simple'
      },
    }
  }
}
